import {
  useEffect,
  useState,
} from "react";

import api from "./api";

export async function recordAndroidSubscription(
  purchaseToken
) {
  if (!purchaseToken) {
    throw new Error(
      "Missing purchase token"
    );
  }

  const { data } = await api.post(
    "/api/subscriptions/record",
    {
      token: purchaseToken,
    }
  );

  return data;
}

export async function recordGoogleSub(
  purchaseToken
) {
  return recordAndroidSubscription(
    purchaseToken
  );
}

export async function refreshPremium() {
  try {
    const { data } = await api.get(
      "/me/subscription"
    );

    return data;
  } catch {
    return null;
  }
}

export function useServerSubscription() {
  const [state, setState] = useState({
    loading: true,
    active: false,
    is_premium: false,
    sub_expiry: null,
  });

  useEffect(() => {
    let mounted = true;

    const normalize = (obj) => {
      if (!obj || typeof obj !== "object") {
        return {
          active: false,
          is_premium: false,
          sub_expiry: null,
        };
      }

      if (
        "active" in obj &&
        "is_premium" in obj
      ) {
        return {
          active: !!obj.active,
          is_premium: !!obj.is_premium,
          sub_expiry:
            obj.sub_expiry || null,
        };
      }

      const is_premium =
        !!obj.is_premium;

      const exp =
        obj.sub_expiry
          ? new Date(obj.sub_expiry)
          : null;

      return {
        active:
          is_premium &&
          (exp
            ? exp > new Date()
            : true),

        is_premium,

        sub_expiry:
          obj.sub_expiry || null,
      };
    };

    (async () => {
      let next = {
        active: false,
        is_premium: false,
        sub_expiry: null,
      };

      try {
        const { data } = await api.get(
          "/me/subscription"
        );

        next = normalize(data);
      } catch (err) {
        if (
          err?.response?.status === 404
        ) {
          try {
            const { data } =
              await api.get("/me");

            next = normalize(data);
          } catch {}
        }
      }

      if (mounted) {
        setState({
          loading: false,
          ...next,
        });
      }
    })();

    return () => {
      mounted = false;
    };
  }, []);

  return state;
}